// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"68b4c265","75":"a231dd8b","116":"3a05150a","207":"29313568","218":"e855c5af","238":"cd17e844","300":"36c9d1f3","401":"821e368c","659":"3a62256c","662":"1fc3e9ca","704":"ae88ed46","904":"3ad20bf2"}[chunkId] + ".chunk.js";
};